import { render, staticRenderFns } from "./LayoutForm.vue?vue&type=template&id=df1a7250&scoped=true"
import script from "./LayoutForm.vue?vue&type=script&lang=js"
export * from "./LayoutForm.vue?vue&type=script&lang=js"
import style0 from "./LayoutForm.vue?vue&type=style&index=0&id=df1a7250&lang=scss&scoped=true"
import style1 from "./LayoutForm.vue?vue&type=style&index=1&id=df1a7250&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1a7250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df1a7250')) {
      api.createRecord('df1a7250', component.options)
    } else {
      api.reload('df1a7250', component.options)
    }
    module.hot.accept("./LayoutForm.vue?vue&type=template&id=df1a7250&scoped=true", function () {
      api.rerender('df1a7250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layout/LayoutForm.vue"
export default component.exports